<template>
  <section>
    <dialog-component
      :dialogData="dialogData"
      :isShow="isShow"
      @cancel="isShow=false"
      @next="handleNext">
      <div class="email-dialog">
        <p class="tip">
          The new email is already registered with another account. Continuing will share their login credentials. Continue?
        </p>
        <div class="email-content">
          <email-tree
            :companies="emailData.companies"
            :email="emailData.email"
          ></email-tree>
        </div>
      </div>
    </dialog-component>
    <verify-eamil-dialog
      v-if="!isEdit"
      ref="verify-email"
      :email="emailData.email"
      @continue="handleContinue">
    </verify-eamil-dialog>
  </section>
</template>

<script>
import emailTree from './email-tree'

import verifyEamilDialog from './verify-email-dailog'
export default {
  name: 'email-dialog',
  components:{
    verifyEamilDialog,
    emailTree
  },
  props:{
    emailData:{
      type:Object,
      default:()=>({})
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      isShow:false,
      linkSent:false
    }
  },
  computed:{
    currentData(){
      return this.emailData||{}
    },
    dialogData(){
      return{
        title:this.isEdit?'Link Account':'Email Already Registered',
        buttonRightText:'Continue'
      }
    },
    editDialogData(){
      return{
        title:'Link Sent',
      }
    }
  },
  methods:{
    handleShow(){
      this.isShow = true
    },
    handleNext(){
      this.isShow = false
      if(this.isEdit)
        this.$emit('continue')
      else
        this.$refs['verify-email'].handleShow()
    },
    handleContinue(){
      this.$emit('continue')
    }
  }
}
</script>

<style scoped lang="scss">
  .email-dialog{
    .tip{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
      word-wrap:break-word;
    }
    .email-content {
      /*margin-left: 15px;*/
      margin-top: 20px;
     ::v-deep ul {
        li {
          &:nth-child(1) {
            .name {
              color: #22863A!important;
              font-weight: 600;
              font-size: 14px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
</style>
